module.exports = __webpack_public_path__ + "static/media/calculadora-react.09723d7f.png";